import DisplayCGFound from './widget-cg-found';
import DisplayCGNotFound from './widget-cg-not-found';
import { IIndividualCustomer } from '../../../../models/customer.interface';

/**
 * Function to display card group information on customer
 * 
 * @param {object} data the customer object
 * 
 * @returns void
 */
const DisplayCardGroupWidget = (data: IIndividualCustomer) => {
  const { cardgroup, customer} = data.body;
  const { customerId, customerName } = customer[0];

  cardgroup.length != 0 ? DisplayCGFound(cardgroup) : DisplayCGNotFound(String(customerId), customerName);
}

export default DisplayCardGroupWidget;